import React from "react";

import Setting from "@app/analytics/account/components/Setting";
import SettingCheckbox from "@app/analytics/account/components/SettingCheckbox";
import SettingContent from "@app/analytics/account/components/SettingContent";
import SettingsModule from "@app/analytics/account/components/SettingsModule";
import { SettingModule } from "@app/analytics/account/types";
import useAccountSettings from "@app/analytics/hooks/settings/useAccountSettings";

const OtherModule = (props: SettingModule) => {
  const { accountSettings, updateAccountSettingsMutation } =
    useAccountSettings();

  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    updateAccountSettingsMutation.mutate({ analyticsOptIn: checked });
  };
  return (
    <SettingsModule {...props}>
      <Setting
        title="Read Customer Experience Program"
        subtitle="A voluntary program that stores meeting data to help improve the features in our service."
      >
        <SettingContent>
          <SettingCheckbox
            label="Yes, I want to participate in the Read Customer Experience Program"
            checked={accountSettings?.analyticsOptIn ?? false}
            onChange={handleChange}
            sx={{ ml: 1 }}
          />
        </SettingContent>
      </Setting>
    </SettingsModule>
  );
};

export default OtherModule;
